function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { Button, ButtonSize, ButtonAppearance, ButtonShape, ButtonColor } from '@tablekit/button';
import { Icon } from '@tablekit/icon';
import { Panel, PanelPosition } from '@tablekit/panel';
import { Size } from '@tablekit/theme';
import { useState } from 'react';
import { ButtonWrapper, ScrollWrapper, Container, LangItem, ItemSubtitle, InlineDialogWrapper } from './styled.js';
import { View } from './types.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';

var LanguageSelector = function LanguageSelector(_ref) {
  var className = _ref.className,
      containerCss = _ref.containerCss,
      _ref$currentLanguage = _ref.currentLanguage,
      currentLanguage = _ref$currentLanguage === void 0 ? 'en' : _ref$currentLanguage,
      onChangeLanguage = _ref.onChangeLanguage,
      locales = _ref.locales,
      _ref$view = _ref.view,
      view = _ref$view === void 0 ? View.Desktop : _ref$view,
      _ref$itemWidth = _ref.itemWidth,
      itemWidth = _ref$itemWidth === void 0 ? '33.33%' : _ref$itemWidth,
      _ref$itemHeight = _ref.itemHeight,
      itemHeight = _ref$itemHeight === void 0 ? 'initial' : _ref$itemHeight,
      inlineDialogContainerCss = _ref.inlineDialogContainerCss,
      renderTrigger = _ref.renderTrigger,
      _ref$shouldShowCloseI = _ref.shouldShowCloseIcon,
      shouldShowCloseIcon = _ref$shouldShowCloseI === void 0 ? false : _ref$shouldShowCloseI;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPanelOpen = _useState2[0],
      setPanelOpen = _useState2[1];

  if (view === View.Mobile) {
    return jsxs(Fragment, {
      children: [renderTrigger({
        onClick: function onClick() {
          setPanelOpen(true);
        },
        isOpen: isPanelOpen,
        ref: null
      }), jsxs(Panel, {
        isOpen: isPanelOpen,
        position: PanelPosition.Bottom,
        togglePanel: function togglePanel() {},
        children: [shouldShowCloseIcon && jsx(ButtonWrapper, {
          children: jsx(Button, {
            size: ButtonSize.Small,
            appearance: ButtonAppearance.Subtle,
            shape: ButtonShape.Circular,
            color: ButtonColor.Ghost,
            onClick: function onClick() {
              return setPanelOpen(false);
            },
            iconBefore: function iconBefore() {
              return jsx(Icon, {
                icon: faTimes
              });
            },
            tabIndex: -1
          })
        }), jsx(ScrollWrapper, {
          children: jsx(Container, {
            css: containerCss,
            children: locales.map(function (item) {
              var _locales$find;

              var isSelected = item.code === currentLanguage;
              return jsxs(LangItem, {
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                isSelected: isSelected,
                "aria-selected": isSelected,
                "data-value": item.code,
                size: Size.Large,
                onClick: function onClick() {
                  onChangeLanguage(item.code);
                  setPanelOpen(false);
                },
                children: [item.label, item.code !== currentLanguage && jsx(ItemSubtitle, {
                  children: (_locales$find = locales.find(function (opt) {
                    return opt.code === currentLanguage;
                  })) === null || _locales$find === void 0 ? void 0 : _locales$find.translations[item.code]
                })]
              }, item.code);
            })
          })
        })]
      })]
    });
  }

  return jsx(InlineDialogWrapper, {
    className: className,
    containerCss: inlineDialogContainerCss,
    renderTrigger: renderTrigger,
    children: function children(_ref2) {
      var onClose = _ref2.onClose;
      return jsx(Container, {
        css: containerCss,
        children: locales.map(function (item) {
          var _locales$find2;

          var isSelected = item.code === currentLanguage;
          return jsxs(LangItem, {
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            isSelected: isSelected,
            "aria-selected": isSelected,
            "data-value": item.code,
            size: Size.Large,
            onClick: function onClick() {
              onChangeLanguage(item.code);
              onClose();
            },
            children: [item.label, item.code !== currentLanguage && jsx(ItemSubtitle, {
              children: (_locales$find2 = locales.find(function (opt) {
                return opt.code === currentLanguage;
              })) === null || _locales$find2 === void 0 ? void 0 : _locales$find2.translations[item.code]
            })]
          }, item.code);
        })
      });
    }
  });
};

export { LanguageSelector };
